import React, { Component } from "react";
import GLOBALS from '../utils/Constants';
import UserService from './users-service';

export default class ActivityLogsService {

    static sharedInstance = ActivityLogsService.sharedInstance == null ? new ActivityLogsService() : this.sharedInstance;

    constructor() {
        //this.checkIfTokenIsValid();
        this.credentials = UserService.sharedInstance.getStoredCredentials();
    }

    async fetchActivityLogs(params){

        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.GET_ACTIVITY_LOGS_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("get activity logs error", error);
        }
    }

    async fetchActivityLogsByDate(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.GET_ACTIVITY_LOGS_DATE_RANGE_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("get activity logs by date error", error);
        }
    }

    //need to add  UserService.sharedInstance.checkIfTokenIsValid(responseJson); here
    getFacilitiesByUserLicense(callback = function(){}){
        const {license,username,token} = this.credentials;

        const param = UserService.sharedInstance.urlEncodeParams({
            token,
            license,
            auth_username:username
        });

        fetch(GLOBALS.GET_ACTIVITY_LOGS_FACILITIES_API + '&' + param)
            .then(res => res.json())
            .then(callback)
            .catch(err => {
                callback({
                    success:0,
                    code_error:'server_error',
                    message:err.message
                });
            });
    }
}